(ns app.home-page.styles
  (:require-macros)
  (:require [garden.stylesheet :refer [at-media]]
            [spade.core   :refer [defclass]]))


(defclass app-bar
  []
  {:padding "8px 24px"
   :align-items "center !important"
   :height "56px"})



(defclass login-app-bar
  []
  {:padding "8px 24px"
   :align-items "center !important"
   :height "56px"
   :min-width "1440px"}
  [(at-media {:max-width "991px"}
             {:min-width "800px"})]
  [(at-media {:max-width "768px"}
             {:min-width "100%"})])
(defclass home-page-container
  []
  {:padding "100px 56px"
   :border-radius "8px"}
  [(at-media {:min-height "300px"}
             {:padding "20px 20px"})])
(defclass home-page
  [] {:background-image "URL('icons/homepage-background.png')"
      :background-position "center"
      :background-repeat "no-repeat"; /* Do not repeat the image */
      :background-size "cover"; /* Resize the background image to cover the entire container */
      })

(defclass home-page-width
  []
  {}
  ;; {:min-width "1440px"}
  ;; [(at-media {:max-width "991px"}
  ;;            {:min-width "800px"})]
  ;; [(at-media {:max-width "768px"}
  ;;            {:min-width "100%"})]
  )

(defclass home-page-title
  [] {}
  [(at-media {:max-width "768px"}
             {:text-align "center"})])

(defclass home-page-buttons
  [] {}
  [(at-media {:max-width "944px"}
             {:flex-flow "column !important"})])

(defclass bar-buttons
  [] {}
  [(at-media {:max-width "768px"}
             {:display "none"})])


(defclass new-workspace-container
  []
  {:background-color "white"
   :padding "25px 40px"
   :border-radius "8px"
   :filter "drop-shadow(0px 10px 30px rgba(0, 0, 0, 0.05)) drop-shadow(0px 20px 50px rgba(0, 0, 0, 0.1)) drop-shadow(0px 4px 70px rgba(0, 0, 0, 0.05))"})
